import { Flame } from "lucide-react";

interface Props {
  show?: boolean | null;
  className?: string;
}

/** Eye-catching chip flagging a job as ColdFusion-related — same pulse/glow treatment
 * as TimeAgoChip/TechTagChip so these (typically rarer, higher-priority) postings
 * don't get lost in the list, but a distinct dark-red gradient (paired with the flame
 * icon) so it doesn't visually blend in with those slate-toned chips. */
export default function ColdFusionChip({ show, className }: Props) {
  if (!show) return null;

  return (
    <span
      className={`flex items-center gap-1 text-[10px] px-2 py-1 rounded-full font-inter font-bold text-white bg-gradient-to-r from-red-900 to-black ring-2 ring-red-500/40 shadow-[0_0_10px_rgba(239,68,68,0.5)] animate-pulse cursor-default shrink-0 ${className ?? ""}`}
    >
      <Flame className="w-3 h-3" />
      Coldfusion
    </span>
  );
}
